<template>
  <div :class="{'hashead':!isPC}" class="home-s2">
    <LeaveTel ref="LeaveTel" :estateItem="estateItem" :isXprtFlag="isXprtFlag" :isFind="isFind"  @setIsFind="getIsFind" ></LeaveTel>
    <Header v-if="isPC"></Header>
    <WapHeader v-if="!isPC" :showlogo="true"></WapHeader>
    <div class="banner">
      <img v-if="recomItem.bannerPath" :src="recomItem.bannerPath">
      <!-- <img :src="logoUrl" class="logo"> -->
      <!-- <img  v-if="!isZS" src="../../static/logo.png" class="logo"> -->
      <div class="bannerinput">
        <p class="bttitle"><!-- 稀缺好房全城热销 --></p>
        <!-- <div v-if="isShowInput"> -->
        <div >
          <div class="inputbox"><input type="tel" placeholder="请输入手机号" v-model="ljdyfydtPhone" ></div>
          <p class="error" v-show="isPhoneError" >请输入正确的手机号码</p>
          <div v-show="codeInputShow!=2?true:false" class="inputbox"><input type="number" placeholder="请输入验证码" v-model="ljdyfydtCode">
            <span class="code" v-show="codeShow" @click="getCode(ljdyfydtPhone)" >获取验证码</span>
            <span class="code" v-show="!codeShow">重新获取{{count}}s</span>
          </div>
          <p class="error" v-show="isCodeError" >{{errorMsg}}</p>
        </div>
        <p class="mbutton" @click="leaveClick(0)" >订阅房源动态</p>
        <p class="tip">*订阅后可获得房源详情，优惠降价提前知悉</p>
      </div>
    </div>
    <div class="userwrap" v-if="recomItem&&(recomItem.ucSw==1||recomItem.usSw==1)">
      <div class="usercount" v-if="recomItem.ucSw==1&&recomItem.userCount!=null"><i class="tzicon"></i><p v-html = recomItem.userCount></p></div>
      <div class="userbox" :class="{'userboxbar':recomItem.userShowType==2}" v-if="recomItem.usSw==1&&recomItem.userShowPlace==1">
        <p class="utitle" v-if="recomItem.userShowType==1"><b>最新报名客户</b></p>
        <i class="m-icon i-huo" v-if="recomItem.userShowType==2"></i>
        <div class="userlist">
          <div class="listbox">
            <div>
              <li :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li></div>
            <div>
              <li v-if="index<5" :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="navbox">
        <ul>
          <li @click="$router.push({path:'/estate?mtxFisrtLocation='+recomItem.mtxFisrtLocation})"><i class="m-icon mi-qblp"></i>全部楼盘</li>
          <li @click="$router.push({path:'/recommendList'})"><i class="m-icon mi-zslp discount"></i>新盘热推</li>
          <li @click="$router.push({path:'/findHouse?id='+recomItem.projectPkId})"><i class="m-icon mi-bwzf new"></i>帮我找房</li>
          <li @click="$router.push({path:'/calculate'})"><i class="m-icon mi-fdjs"></i>房贷计算</li>
        </ul>
    </div>

    <div class="box">
      <div class="recombox">
        <div v-if="recomItem.estateList" class="clearfix">
          <div class="rtitle"><b class="title">高性价比楼盘热销榜</b><i></i><span>海量房源</span><span>真实性价比</span><span>真实成交价</span></div>
          <div v-for="(item,index) in recomItem.estateList" :key="index">
            <div class="recomitem" :class="{'ml0':index%3==0}">
              <div class="imgbox">
                <!-- <img v-lazy="item.path+'&size=600x300'" /> -->

                <i v-if="item.tvUrl&&item.tvUrl!=''" class="i-video" @click="currVideoPath=item.tvUrl"></i>
                <img v-lazy="item.path+'&type=1&size=600x300'" @click="$router.push({path:'/estateDetail?estateId='+item.estateId})" />
              </div>
              <span class="name" @click="$router.push({path:'/estateDetail?estateId='+item.estateId})">{{item.estateName}}</span>
              <div class="infobox" @click="$router.push({path:'/estateDetail?estateId='+item.estateId})">
                <p class="long">地址：[{{item.locationSt}}-{{item.locationSC}}] {{item.positionDetail}}</p>
                <p>优势：{{item.advantage}}</p>
                <p>户型：{{item.mTouseholdType}}</p>
                <p>建面：{{item.acreage}}</p>
              </div>
              <div class="btnbox clearfix">
                <span @click="$refs.LeaveTel.leaveCallClick(item.phone,item.estateId,item.estateName,recomItem.hotName,recomItem.projectPkId)"><a href="javascript:void(0);" class="mltell">电话咨询</a></span>
                <span @click="$refs.LeaveTel.leaveClick(24,item.estateId,item.estateName,recomItem.hotName,recomItem.projectPkId,true,)">获取最新报价</span>
              </div>
              <div class="kfsbox" v-show="showPermitFlag">
                  <p v-if="item.developerName && item.developerName!=''">开发商：{{item.developerName}}</p>
                  <p v-if="item.permit && item.permit!=''">预售证号：{{item.permit}}</p>
              </div>
            </div>
            <div class="userwrap" v-if="recomItem.usSw==1&&(index==parseInt(recomItem.estateList.length/2)-1)&&recomItem.userShowPlace==2">
              <div class="userbox" :class="{'userboxbar':recomItem.userShowType==2}" v-if="recomItem.usSw==1">
                <p class="utitle" v-if="recomItem.userShowType==1"><b>最新报名客户</b></p>
                <i class="m-icon i-huo" v-if="recomItem.userShowType==2"></i>
                <div class="userlist">
                  <div class="listbox">
                    <div>
                      <li :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li></div>
                    <div>
                      <li v-if="index<5" :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="userwrap" v-if="recomItem&&recomItem.usSw==1&&recomItem.userShowPlace==3">
          <div class="userbox" :class="{'userboxbar':recomItem.userShowType==2}" v-if="recomItem.usSw==1">
            <p class="utitle" v-if="recomItem.userShowType==1"><b>最新报名客户</b></p>
            <i class="m-icon i-huo" v-if="recomItem.userShowType==2"></i>
            <div class="userlist">
              <div class="listbox">
                <div>
                  <li :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li></div>
                <div>
                  <li v-if="index<5" :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span class="showForm" @click="hideForm=false"></span>
        <div class="formwrap" :class="{'hide':hideForm&&isPC}">
          <span class="colse" @click="hideForm=true">关闭</span>
          <div class="rtitle r1"><p class="title">­­­­找不到满意的楼盘？<br>填写信息，为您精确匹配房源</p><i></i></div>
          <div class="formbox">
            <span class="icon"><i class="m-icon mi-fmdq"></i></span>
            <el-select v-model="dqvalue" placeholder="请选择您所在的区">
              <el-option v-for="(item,index) in dqoptions" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </div>
          <div class="formbox">
            <span class="icon"><i class="m-icon mi-fmhx"></i></span>
            <el-select v-model="hxvalue" placeholder="请选择您喜欢的户型">
              <el-option v-for="(item,index) in hxoptions" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </div>
          <div class="formbox">
            <span class="icon"><i class="m-icon mi-fmys"></i></span>
            <el-select v-model="ysvalue" placeholder="请选择您的购房预算">
              <el-option v-for="(item,index) in ysoptions" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </div>
          <div class="formbox">
            <span class="icon"><i class="m-icon mi-fmsj"></i></span>
            <input type="tel" placeholder="请输入您的手机号" v-model="spfyPhoneValue" >
          </div>
          <p class="error" v-show="isPhoneError" >请输入正确的手机号码</p>

          <div v-show="codeInputShow==1?true:false" class="formbox codebox">
            <span class="icon"><i class="m-icon mi-ys"></i></span>
            <input type="tel" placeholder="请输入验证码" v-model="spfyPhoneCode" />
            <p class="code wait" v-show="!codeShow">{{count}}s</p>
            <p class="code" v-show="codeShow" @click="getCode(spfyPhoneValue)">获取验证码</p>
          </div>
          <p class="error" v-show="isCodeError" >{{errorMsg}}</p>
          <div class="formbox b">
            <p class="mbutton" @click="leaveSpfyClick">立即匹配房源</p>
          </div>
        </div>
      </div>
    </div>
    <VideoPlay :videoPath="currVideoPath" @clearPath="currVideoPath=''"></VideoPlay>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/public/Header'
import WapHeader from '@/components/public/WapHeader'
import LeaveTel from '@/components/public/LeaveTel'
import Footer from '@/components/public/Footer'
import VideoPlay from '@/components/public/VideoPlay'
export default {
  name: 'Recommend',
  components:{
    'Header':Header,
    'WapHeader':WapHeader,
    'LeaveTel':LeaveTel,
    'Footer':Footer,
    'VideoPlay':VideoPlay
  },
  data () {
    return {
      isPC:this.$store.state.isPC,
      isShowInput:false,
      recomItem:[],
      userItem:[],
      dqvalue:'',
      dqoptions:[],
      hxvalue:'',
      hxoptions:[
        {name:'一室',id:'000'},
        {name:'两室',id:'001'},
        {name:'三室',id:'002'},
        {name:'四室',id:'003'},
        {name:'五室',id:'004'},
        {name:'五室以上',id:'005'},
      ],
      codeShow:true,
      count: '',
      timer: null,
      ysvalue:'',
      ysoptions:[],
      isFind:false,
      isXprtFlag:true,
      estateItem:[],
      hideForm:true,
      spfyPhoneValue:null,
      spfyPhoneCode:null,
      ljdyfydtPhone:null,
      ljdyfydtCode:null,
      isPhoneError:false,
      isCodeError:false,
      errorMsg:'请输入验证码',
      codeInputShow: 0,
      currVideoPath:'',
      showPermitFlag:false
    }
  },
  computed:{
    listenIsPC(){
      return this.$store.state.isPC;
    }
  },
  watch:{
    listenIsPC:function(boo){
      this.isPC = this.$store.state.isPC;
    }
  },
  mounted(){
    var _this = this;
   
    _this.getRecom();
     //判断是否是baidu渠道进来的,显示开发商和预售许可
     var channel = this.$route.query.channel;
      if(sessionStorage.getItem('channel')!=null){
        channel  = sessionStorage.getItem('channel');
      }
      if(channel && channel.indexOf('baidu')!=-1){
        _this.showPermitFlag = true;
      }
  },
  methods:{
    getRecom:function(){
      this.$http.get('/api/baidu/getHotThemeEstateList?id='+this.$route.query.id).then((response)=>{
        this.recomItem = response.data.result
        this.estateItem = response.data.result.estateList
        this.userItem = response.data.result.usList
      }).catch((response)=>{
        console.log(response)
      })
      this.$http.get('/api/estateSearch/getLocationParams?locationId='+this.storage.get('city').citySite).then((response)=>{
        this.dqoptions = response.data.result.locationList
      }).catch((response)=>{
        console.log(response)
      })
      this.$http.get('/api/estateSearch/getPurchaseParams').then((response)=>{
        this.ysoptions = response.data.result.budgetList
      }).catch((response)=>{
        console.log(response)
      })
    },
    getIsFind:function(data){
      this.ljdyfydtPhone ='';
      this.ljdyfydtCode ='';
      this.isFind = data;
    },
    getCode: function(mobile){

      //校验手机号码
      if(!this.$refs.LeaveTel.checkPhone(mobile)){
        this.isPhoneError =true;
        return false;
      }
      this.isPhoneError =false;
      const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.codeShow = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
              } else {
              this.codeShow = true;
              clearInterval(this.timer);
              this.timer = null;
              }
            }, 1000)
          }

      //获取验证码
      this.$http.get('/api/user/getSmscode?mobile='+mobile).then((response)=>{
        console.log(response);
        if(response.data.result && !response.data.result.resultCode && response.data.result.msg!=null){
          this.isCodeError = true;
          this.errorMsg =  response.data.result.msg;
        }else{
          this.isCodeError = false;
          this.errorMsg = '';
        }
      }).catch((response)=>{
        console.log(response)
      })
    },
    leaveClick:function(index){
      // if(!this.isShowInput){
      //   this.isShowInput = true;
      //   return false;
      // }
      //校验手机号码
     if(!this.$refs.LeaveTel.checkPhone(this.ljdyfydtPhone)){
        this.isPhoneError =true;
        return false;
      }
       this.isPhoneError =false;


       if(this.codeInputShow==0 || this.codeInputShow==1){
        if(this.ljdyfydtCode==null || this.ljdyfydtCode==''){
          this.isCodeError =true;
          return false;
        }

        //校验验证码
        this.$http.get('/api/user/checkSmsCode?mobile='+this.ljdyfydtPhone+'&smsCode='+this.ljdyfydtCode).then((response)=>{
          console.log(response);
          if(!response.data.result){
            this.isCodeError = true;
            this.errorMsg = '验证码错误';
            return false;
          }
          this.isCodeError = false;
          this.errorMsg = '请输入验证码';
          this.$refs.LeaveTel.setParams(23,null,null,this.recomItem.hotName,this.recomItem.projectPkId,null,this.ljdyfydtPhone);
          this.$refs.LeaveTel.sendFromInLine();
          this.isFind =true;
        }).catch((response)=>{
          console.log(response)
          this.isCodeError = true;
          this.errorMsg = '验证码错误';
          return false;
        })
       }else{
         this.isCodeError = false;
          this.errorMsg = '请输入验证码';
          this.$refs.LeaveTel.setParams(23,null,null,this.recomItem.hotName,this.recomItem.projectPkId,null,this.ljdyfydtPhone);
          this.$refs.LeaveTel.sendFromInLine();
          this.isFind =true;
       }
    },
    leaveSpfyClick:function(){
      // 校验手机号码
      if(!this.$refs.LeaveTel.checkPhone(this.spfyPhoneValue)){
        this.isPhoneError =true;
        return false;
      }
      this.isPhoneError =false;

       //判断是否需要验证码校验,并且只有新盘热推界面过来的才需要校验
      if(this.codeInputShow==1){
        if(this.spfyPhoneCode==null || this.spfyPhoneCode==''){
          this.isCodeError =true;
          this.errorMsg = '请输入验证码';
          return false;
        }

        //校验验证码
        this.$http.get('/api/user/checkSmsCode?mobile='+this.spfyPhoneValue+'&smsCode='+this.spfyPhoneCode).then((response)=>{
          console.log(response);
          if(!response.data.result){
            this.isCodeError = true;
            this.errorMsg = '验证码错误';
            return false;
          }
          this.isCodeError = false;
          this.errorMsg = '请输入验证码';
          this.submit();
        }).catch((response)=>{
          console.log(response)
          this.isCodeError = true;
          this.errorMsg = '验证码错误';
          return false;
        })

      }else{
        this.submit();
      }
    },
    submit:function(){
        var remark = "所在区域:["+ this.dqvalue +"] 喜欢的户型：["+ this.hxvalue+ "] 购房预算:["+ this.ysvalue +']';
        this.$refs.LeaveTel.setParams(25,null,null,this.recomItem.hotName,this.recomItem.projectPkId,remark,this.spfyPhoneValue);
        this.$refs.LeaveTel.sendFromInLine();
        this.isFind = true;
        //提交后，清空输入信息
        this.dqvalue = '';
        this.hxvalue = '';
        this.ysvalue = '';
        this.spfyPhoneValue = null;
        this.spfyPhoneCode = null;
    }
  }
}
</script>

<style scoped>
  .banner+.userwrap{padding-top:20px;padding-bottom:5px;}
  .banner .logo{width:80px;height:auto;position:absolute;left:50%;top:0px;margin-left:-40px;z-index:1;padding:8px 0 7px;border-radius:5px;border-top-right-radius:0;border-top-left-radius:0;}
  .home-s2{background:#f5fafe;}
  .navbox{margin-top:15px;}
  .navbox{background:#fff;padding:15px 10px 10px;}
  .navbox ul{display:table;width:100%;text-align:center;}
  .navbox li{display:table-cell;line-height:24px;}
  .navbox li .m-icon{display:block;margin:0 auto;width:44px;height:44px;}
  .navbox,.bannerinput{box-shadow:0 1px 3px rgba(127,127,127,.5);}
  .m-icon.new,.m-icon.discount{position:relative;}
  .m-icon.new:before,.m-icon.discount:before{content:'';position:absolute;top:-5px;left:28px;height:14px;background:url(../assets/images/icons.png) no-repeat;background-size:225px;}
  .m-icon.new:before{width:14px;background-position:-155px 0;}
  .m-icon.discount:before{width:26px;background-position:-170px 0;}
  .mi-qblp{background-position:0 -34px;}
  .mi-zslp{background-position:-90px -34px;}
  .mi-bwzf{background-position:-45px -34px;}
  .mi-fdjs{background-position:-135px -34px;}

  .recomitem,.formwrap{background:#fff;box-shadow:0 2px 5px rgba(127,127,127,.5);border-radius:10px;}
  .mbutton{font-weight:700;letter-spacing:2px;height:40px;line-height:40px;}
  .banner{position:relative;background:#000;}
  .banner img{width:100%;height:100%;object-fit:cover;display:block;}
  .bannerinput{background:#fff;padding:15px 20px;text-align:center;color:#000;position:relative;}
  .bannerinput:before{content:"";position:absolute;left:0;right:0;top:-72px;height:72px;background:url(../../static/recommend/images/xprt1.png);background-size:100% 72px;}
  .bttitle{height:24px;background:url(../../static/recommend/images/xprt2.png) center no-repeat;background-size:auto 24px;margin-bottom:15px;}
  .error{color:#F44336;font-size:12px;text-align:left;padding-top:5px;padding-left:20px;}
  .banner .mbutton{margin-top:15px;border-radius:8px;background:#ffd800;color:#000;}
  .tip{font-size:12px;line-height:18px;margin-top:8px;}
  .inputbox{height:20px;padding:9px 20px;border:1px solid #d2d2d2;border-radius:8px;line-height:20px;position:relative;margin-top:10px;overflow:hidden;}
  .inputbox input{display:block;width:100%;font-size:15px;line-height:20px;}
  .inputbox span{position:absolute;width:35%;right:0;top:0;line-height:38px;color:#dc9806;text-decoration:underline;font-size:13px;}
  .inputbox span:before{content:'';position:absolute;left:0;top:5px;bottom:5px;border-left:1px solid #d2d2d2;}

  .rtitle{text-align:center;margin-top:15px;padding-bottom:5px;position:relative;color:#dc9806;}
  .rtitle .title{display:block;font-size:19px;color:#000;line-height:25px;letter-spacing:1px;z-index:1;position:relative;}
  .rtitle i{width:190px;margin:-6px auto 0;height:6px;border-radius:3px;background:#ff9f1a;display:block;}
  .rtitle span{display:inline-block;padding:0 15px;font-size:12px;margin-top:15px;line-height:14px;}
  .rtitle span+span{border-left:1px solid #f6b86d;}
  .rtitle.r1 .title{font-size:17px;}
  .rtitle.r1 i{width:246px;margin-top:-8px;}

  .recomitem{margin-top:15px;position:relative;padding:55px 165px 15px 0;}
  .recomitem .imgbox{position:absolute;right:10px;top:50px;width:150px;height:120px;border-radius:15px;overflow:hidden;}
  .recomitem img{width:100%;height:100%;}
  .name{position:absolute;left:-10px;top:15px;font-size:18px;color:#fff;box-shadow:0 2px 4px rgba(52,8,181,.36);padding:0 15px 0 10px;line-height:33px;background:linear-gradient(45deg,#58a9f9 0,#0075da 100%);}
  .name:before{content:"";position:absolute;left:0;bottom:-10px;border:5px solid transparent;border-top-color:#0059a5;border-right-color:#0059a5}
  .name:after{content:"";position:absolute;right:-3px;top:-11px;border:18px solid transparent;border-right-color:#fff;border-bottom-color:#fff;border-width:25px 6px;}
  .infobox{padding-left:10px;min-height:111px;}
  .infobox p{font-size:12px;line-height:18px;margin-top:7px;position:relative;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .infobox .long{max-height:36px;white-space:normal;}
  .mi-ys{width:13px;height:14px;background-position:0 -19px;top:1px;left:2px;}
  .btnbox{padding:15px 15px 0;margin-right:-165px;}
  .btnbox span{width:40%;float:left;}
  .btnbox span+span{float:right;width:56%;}
  .btnbox span,.formbox .mbutton{padding-left:2px;letter-spacing:2px;text-shadow:0 2px 1px #cf880d;box-shadow:0 2px 4px #cf880d;background: linear-gradient(45deg,#ffa802 0,#ffd800 100%);line-height:40px;height:40px;color:#fff;border-radius:20px;text-align:center;font-size:18px;}
  .formwrap{padding:1px 15px 15px;margin-top:20px;}
  .formbox{background:#e4e4e4;height:40px;border-radius:20px;margin-top:10px;padding-left:50px;overflow:hidden;position:relative;}
  .icon{position:absolute;left:7px;top:0;width:50px;height:40px;text-align:center;}
  .mi-fmdq{width:16px;height:18px;background-position:-98px -15px;margin-top:12px;}
  .mi-fmhx{width:17px;height:15px;background-position:-14px -18px;margin-top:13px;}
  .mi-fmys{width:16px;height:17px;background-position:-81px -16px;margin-top:12px;}
  .mi-fmsj{width:14px;height:21px;background-position:-115px -12px;margin-top:10px;}
  .formbox.b{padding:0;height:40px;line-height:40px;box-shadow:0 2px 8px #f4df9c;margin-top:15px;}
  .formbox .mbutton{font-weight:400;font-size:20px;}
  .formbox input{height:20px;line-height:20px;padding:10px 10px;font-size:14px;width:80%;background:none;}
  .formbox+.error{padding-left:60px;}
  .formbox >>> .el-select{display:block;}
  .formbox >>> .el-input__inner{border:0;background:none;line-height:40px;height:40px;padding-left:10px;color:#333;font-size:14px;}
  .formbox.codebox input{width:60%;}
  .codebox .code{position:absolute;right:15px;top:10px;color:#dc9806;text-decoration:underline;}
  .codebox .code.wait{top:12px;color:#aaa;text-decoration:none;}
  .codebox .mi-ys{margin-top:14px;}
  .kfsbox{margin-right:-165px;padding:0 10px;font-size:12px;line-height:16px;text-align:center;color:#888;margin-top:15px;}
  .kfsbox p{margin-top:3px;}

@media (max-width:768px){
  .recombox{padding:5px 15px 20px;}
  .colse{display:none;}
  .i-video{position:absolute;left:50%;top:50%;margin-left:-20px;margin-top:-20px;width:40px;height:40px;border-radius:50%;background:#fff url(../assets/images/i-video.png) 14px center no-repeat;background-size:17px;box-shadow:2px 2px 20px rgba(0,0,0,.5);z-index:1;}
}
@media (min-width:769px){
  .rtitle{line-height:30px;margin-top:50px;}
  .recomitem{display:inline-block;width:31%;margin-top:30px;float:left;margin-left:3.5%;box-sizing:border-box;height:400px;}
  .recomitem.ml0{margin-left:0;}
  .recomitem img{height:200px;}
  .name{top:167px;}
  .btnbox span:first-child{display:none;}
  .btnbox span+span{float:none;display:block;width:100%;cursor:pointer;}
  .infobox p{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .formwrap{position:fixed;right:10px;bottom:50px;background:#fff;padding:20px;width:320px;box-shadow:0 8px 20px rgba(76,37,30,.18);border-radius:5px;border:1px solid #dcdad2;z-index:1;}
  .formwrap .rtitle{margin-top:0;padding-bottom:5px;}
  .hide{display:none;}
  .colse{position:absolute;right:15px;top:12px;color:#999;font-size:12px;display:inline;cursor:pointer;}
  .bannerinput{width:300px;margin:0 auto;}
  .showForm{background:url(../assets/images/wnyx.png);width:100px;height:107px;position:fixed;right:0;bottom:100px;}
}
</style>



// WEBPACK FOOTER //
// src/components/Recommend1.vue